<template>
    <div>
        <div class="col-12 position-relative">
            <label class="form-label" for="upsells">
                <strong>Add upsell services</strong>
            </label>
            <input class="form-control autocomplete" aria-label="Upsell Service" ref="autocomplete" id="autocomplete" placeholder="Search..." @keyup="searchUpsells($event)">
            <div id="output" v-if="showSuggestions">
                <ul>
                    <li v-for="upsellItem in allUpsellsFiltered" @click="selectUpsellService(upsellItem.id)">{{ upsellItem.name }}</li>
                </ul>
            </div>
        </div>

        <div class="col-12 text-left extraServices">
            <div v-if="typeof this.upsells.data !== 'undefined' && this.upsells.data.length > 0">
                <div class="row head pt-2 font-bold text-sm">
                    <div class="col-md-4">Service title</div>
                    <div class="col-md-3">Image</div>
                    <div class="col-md-1 text-center">Price</div>
                    <div class="col-md-2 text-center">Discount</div>
                    <div class="col-md-2 text-center"></div>
                </div>
                <div class="row p-2" v-for="item in this.upsells.data" :key="item.id">
                    <div class="col-md-4 p-2 text-wrap">{{ item.service.name }}</div>
                    <div class="col-md-3 p-2">
                        <img :src="item.service.photo_path" alt="" class="d-block mb-1" style="max-width:100px" v-if="item.service.photo_path">
                        <span v-else>N/A</span>
                    </div>
                    <div class="col-md-1 p-2 text-center">{{ currencySymbol }}{{ item.service.price }}</div>
                    <div class="col-md-2 p-2 text-center">{{ item.service.discount }}</div>
                    <div class="col-md-2 text-center">
                        <a class="btn btn-square btn-danger rounded-circle p-2 ms-2" @click="remove(item.id)"><span class="svg-icon"><i class="bi bi-archive"></i></span></a>
                    </div>
                </div>
            </div>
            <span v-else>No upsell services.</span>
        </div>
    </div>
</template>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: scroll;
}
.form-check-input {
    width: 30px;
    height: 30px;
}
#output {
    position: absolute;
    background: #fff;
    box-shadow: 0 2px 6px #ccc;
    border-radius: 5px;
    width: 100%;
}
#output ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
#output ul li {
    padding: 1em;
}
#output ul li:hover {
    background: #efefef;
    cursor: pointer;
}
</style>

<script>
import Form from "../helpers/Form";
export default {
    mixins: [Form],
    props: [
        'service_id'
    ],
    data: function () {
        return {
            upsells: [],
            durations: [],
            showImagePreview: true,
            currencySymbol: window.currencySymbol,
            allUpsells: [],
            allUpsellsFiltered: [],
            showSuggestions: false,
        }
    },
    methods: {
        getUpsells() {
            return axios
                .get(`/api/admin/services/${this.service_id}/upsells`)
                .then(res => {
                    this.upsells = res.data;
                });
        },
        getAllUpsells() {
            return axios
                .get(`/api/admin/services`)
                .then(res => {
                    this.allUpsells = res.data.data;
                });
        },
        remove(id) {
            axios
                .delete(`/api/admin/services/${this.service_id}/upsells/${id}`)
                .then(res => {
                    this.onSuccess(res.data.message);
                    this.getUpsells();
                    this.getAllUpsells();
                    this.clearSuggestions();
                })
                .catch((error) => {
                    if (error && error.response.status == 422) {
                        this.setErrors(error.response.data.errors);
                    } else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        searchUpsells(e) {
            const value = e.target.value;
            if (value.length < 2) {
                this.showSuggestions = false;
                return;
            }
            this.allUpsellsFiltered = this.allUpsells.filter((item) => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
            this.showSuggestions = this.allUpsellsFiltered.length;
        },
        selectUpsellService(id) {
            this.clearSuggestions();
            axios
                .post(`/api/admin/services/${this.service_id}/upsells/${id}`)
                .then(res => {
                    this.onSuccess(res.data.message);
                    this.getUpsells();
                    this.getAllUpsells();
                })
                .catch((error) => {
                    if (error && error.response.status == 422) {
                        this.setErrors(error.response.data.errors);
                    } else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        reloadAutocomplete() {
            const existingIds = this.upsells.data.map(i => i.id);
            this.allUpsells = this.allUpsells.filter(i => !existingIds.includes(i.id));
        },
        clearSuggestions() {
            this.showSuggestions = false;
            this.$refs.autocomplete.value = '';
        },
        loadUpsells() {
            Promise.all([this.getUpsells(), this.getAllUpsells()]).then(() => this.reloadAutocomplete());
        }
    },
}
</script>
